export default __webpack_public_path__ + "static/media/369.622f419b.png";